import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { initialFormData, ISubCaste } from "..";
import axiosClient from "../../../../../utils/api/axiosClient";
import { getToken } from "../../../../../utils/functions";
import { ICaste } from "../../cast";
import { IReligion } from "../../religion";
import { SubCasteSchema } from "../validation";

export default function FormModel(props: any) {
  const { setSubCastes, setInitial, modalShow, setModalShow } = props;
  const initial = props.initial as ISubCaste;
  const castes = props.castes as ICaste[];
  const religions = props.religions as IReligion[];

  const [tempCastes, setTempCastes] = useState<ICaste[]>([]);

  const handleSubmit = (values: ISubCaste) => {
    const headers = { Authorization: getToken() };
    const payload = {
      name: values.name,
      casteId: values.casteId,
      religionId: values.religionId,
    };
    if (initial.id) {
      axiosClient
        .put("v1/sub-castes/" + initial.id, payload, { headers })
        .then((res) => {
          if (res.status === 200) setSubCastes(res.data);
        });
    } else {
      axiosClient.post("v1/sub-castes", payload, { headers }).then((res) => {
        if (res.status === 200) setSubCastes(res.data);
      });
    }
    values.name = "";
    values.casteId = 0;
    values.religionId = 0;
    setInitial(initialFormData);
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add/Edit State
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initial}
          validationSchema={SubCasteSchema}
          onSubmit={handleSubmit}
        >
          {({
            touched,
            errors,
            isSubmitting,
            values,
            handleChange,
            handleBlur,
          }) => (
            <Form className="auth-form login-form">
              <div className="email mb-3">
                <label htmlFor="name">Select Religion</label>
                <select
                  name="religionId"
                  value={values.religionId}
                  onChange={(e) => {
                    const religionId = parseInt(e?.target?.value);
                    const tempCastes = castes.filter(
                      (c) => c.religionId === religionId
                    );
                    setTempCastes(tempCastes);
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  className={`mt-2 form-control ${
                    touched.religionId && errors.religionId ? "is-invalid" : ""
                  }`}
                >
                  <option value="" label="Select a Reigion">
                    Select a Reigion{" "}
                  </option>
                  {religions.map((religion, index) => {
                    return (
                      <option
                        key={index}
                        value={religion.id}
                        label={religion.name}
                      >
                        {religion.name}
                      </option>
                    );
                  })}
                </select>

                <ErrorMessage
                  component="div"
                  name="religionId"
                  className="invalid-feedback"
                />
              </div>
              <div className="casteid mb-3">
                <label htmlFor="casteId">Select Caste</label>
                <select
                  name="casteId"
                  value={values.casteId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`mt-2 form-control ${
                    touched.casteId && errors.casteId ? "is-invalid" : ""
                  }`}
                >
                  <option value="" label="Select a Caste">
                    Select a Caste{" "}
                  </option>
                  {tempCastes.map((caste, index) => {
                    return (
                      <option key={index} value={caste.id} label={caste.name}>
                        {caste.name}
                      </option>
                    );
                  })}
                </select>

                <ErrorMessage
                  component="div"
                  name="casteId"
                  className="invalid-feedback"
                />
              </div>
              <div className="email mb-3">
                <label htmlFor="name">Sub Caste Name</label>
                <Field
                  id="name"
                  name="name"
                  values={initial.name}
                  placeholder="Enter Sub Caste Name"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.name && errors.name ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="name"
                  className="invalid-feedback"
                />
              </div>
              <div className="extra mt-3 row justify-content-between">
                <div className="col-6">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="status">
                      Is active ?
                    </label>
                    <input
                      id="status"
                      name="status"
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                    />
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn app-btn-primary w-100 theme-btn mx-auto"
                >
                  SAVE
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
